import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { FaArrowUp, FaArrowDown } from 'react-icons/fa';
import { getButtons, saveButtons, resetButtonsToDefaults, setHasChanges } from '../../../../actions/infoKiosk';
import CustomCheckbox from '../../../../assets/CustomCheckbox/CustomCheckbox';
import Confirmation from '../../../../assets/Confirmation/Confirmation';
import Loader from 'react-loader';
import styles from './styles.module.scss';

const MainMenuTab = ({
  buttons,
  loading,
  hasChanges,
  updateRight,
  getButtons,
  saveButtons,
  resetButtonsToDefaults,
  setHasChanges
}) => {
  const [localButtons, setLocalButtons] = useState([]);
  const [errors, setErrors] = useState({});
  const [showResetConfirm, setShowResetConfirm] = useState(false);
  const [globalError, setGlobalError] = useState('');

  useEffect(() => {
    getButtons();
  }, [getButtons]);

  useEffect(() => {
    if (buttons?.length) {
      setLocalButtons(buttons.map((b, i) => ({
        ...b,
        id: b.id || b.button_key || i
      })));
    }
  }, [buttons]);

  const validateButtons = () => {
    const newErrors = {};
    let hasVisibleButton = false;

    localButtons.forEach((button, index) => {
      if (button.is_visible) {
        hasVisibleButton = true;
        const label = button.system_name || '';
        if (!label.trim()) {
          newErrors[index] = 'Подпись обязательна для видимых кнопок';
        } else if (label.length > 20) {
          newErrors[index] = 'Максимум 20 символов';
        }
      }
    });

    setErrors(newErrors);

    if (!hasVisibleButton) {
      setGlobalError('Должна быть хотя бы одна видимая кнопка');
      return false;
    }

    setGlobalError('');
    return Object.keys(newErrors).length === 0;
  };

  const handleButtonChange = (index, field, value) => {
    const newButtons = [...localButtons];
    newButtons[index] = { ...newButtons[index], [field]: value };
    setLocalButtons(newButtons);
    setHasChanges(true);

    // Clear error for this field if it exists
    if (errors[index]) {
      const newErrors = { ...errors };
      delete newErrors[index];
      setErrors(newErrors);
    }
    setGlobalError('');
  };

  const moveButton = (index, direction) => {
    const newIndex = index + direction;
    if (newIndex < 0 || newIndex >= localButtons.length) return;

    const newButtons = [...localButtons];
    [newButtons[index], newButtons[newIndex]] = [newButtons[newIndex], newButtons[index]];

    // Update display_order
    newButtons.forEach((btn, idx) => {
      btn.display_order = idx + 1;
    });

    setLocalButtons(newButtons);
    setHasChanges(true);
  };

  const handleSave = () => {
    if (!validateButtons()) return;

    const dataToSave = localButtons.map((b, idx) => ({
      button_key: b.button_key,
      system_name: b.system_name,
      display_order: idx + 1,
      is_visible: b.is_visible
    }));
    saveButtons(dataToSave);
  };

  const handleReset = () => {
    resetButtonsToDefaults();
    setShowResetConfirm(false);
    setHasChanges(false);
  };

  if (loading && !localButtons.length) {
    return <div className={styles.loader}><Loader color="#7b2b2a" loaded={false} /></div>;
  }

  return (
    <div className={styles.mainMenuTab}>
      <div className={styles.tableHeader}>
        <span>Подпись кнопки</span>
        <span>Ключ</span>
        <span>Видимость</span>
        <span>Порядок</span>
      </div>

      <div className={styles.buttonsList}>
        {localButtons.map((button, index) => (
          <div key={button.id} className={styles.buttonRow}>
            <div className={`${styles.nameInput} ${errors[index] ? styles.inputError : ''}`}>
              <input
                value={button.system_name || ''}
                onChange={(e) => handleButtonChange(index, 'system_name', e.target.value)}
                disabled={!updateRight}
                maxLength={20}
                placeholder="Подпись кнопки"
              />
              {errors[index] && <div className={styles.errorText}>{errors[index]}</div>}
            </div>

            <div className={styles.systemLabel}>
              {button.button_key}
            </div>

            <div className={styles.visibilityCell}>
              <CustomCheckbox
                checked={button.is_visible || false}
                onChange={(e) => handleButtonChange(index, 'is_visible', e.target.checked)}
                disabled={!updateRight}
              />
            </div>

            <div className={styles.orderButtons}>
              <button
                type="button"
                onClick={() => moveButton(index, -1)}
                disabled={index === 0 || !updateRight}
                title="Вверх"
              >
                <FaArrowUp />
              </button>
              <button
                type="button"
                onClick={() => moveButton(index, 1)}
                disabled={index === localButtons.length - 1 || !updateRight}
                title="Вниз"
              >
                <FaArrowDown />
              </button>
            </div>
          </div>
        ))}
      </div>

      {localButtons.length === 0 && !loading && (
        <p className={styles.emptyMessage}>Нет данных для отображения</p>
      )}

      {globalError && <div className={styles.globalError}>{globalError}</div>}

      {updateRight && (
        <div className={styles.actions}>
          <button
            className={styles.saveBtn}
            onClick={handleSave}
            disabled={!hasChanges || loading}
          >
            {loading ? 'Сохранение...' : 'Сохранить'}
          </button>
          <button
            className={styles.resetBtn}
            onClick={() => setShowResetConfirm(true)}
            disabled={loading}
          >
            Сбросить к значениям по умолчанию
          </button>
        </div>
      )}

      {showResetConfirm && (
        <Confirmation
          title="Сбросить подписи кнопок к значениям по умолчанию?"
          acceptConfirmation={handleReset}
          rejectConfirmation={() => setShowResetConfirm(false)}
        />
      )}
    </div>
  );
};

const mapStateToProps = ({ infoKiosk }) => ({
  buttons: infoKiosk.buttons,
  loading: infoKiosk.buttonsLoading,
  hasChanges: infoKiosk.hasChanges
});

export default connect(mapStateToProps, {
  getButtons,
  saveButtons,
  resetButtonsToDefaults,
  setHasChanges
})(MainMenuTab);
